// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HfWhN","header":"styles_header__ivwVE"};